export const environment = {
    production: false,
    EnvironmentURL: '../environment.json',
    StatusURL: '../status.json',
};